module.exports = __webpack_public_path__ + "img/happy.6fbe0547.png";